import CompanyBrand from "../subs/CompanyBrand.js";
import logo from "../../imgs/logo.png";

const Footer = ({cr_year}) => {
  return (
    <footer>
      <section className="section_top">
        <CompanyBrand type={"full"} logo={logo} />
      </section>
      <section className="section_middle">
        <a href="www.securetech.lk/about" target="_blank" rel="noopener noreferrer">Home</a>
        <a href="www.securetech.lk/services" target="_blank" rel="noopener noreferrer">Services</a>
        <a href="www.securetech.lk/contact" target="_blank" rel="noopener noreferrer">Contact</a>
      </section>
      <section className="section_bottom">
        <p>Copyright&nbsp;&copy;&nbsp;{cr_year}</p>
      </section>
    </footer>
  );
}

export default Footer;